import MuiLink, { LinkProps as MuiLinkProps } from '@mui/material/Link';
import { makeStyles } from '@shared/theme';
import { forwardRef } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  root: {
    cursor: 'pointer',
  },
}));

type Props = MuiLinkProps & { to?: RouterLinkProps['to'] };
const Link: FFC<Props, HTMLAnchorElement> = (props, ref) => {
  const { classes, cx } = useStyles();
  const LinkBase = MuiLink as any;
  const Anchor = props.to ? RouterLink : 'a';
  return (
    <LinkBase
      ref={ref}
      variant="body2"
      component={Anchor}
      {...props}
      className={cx(classes.root, props.className)}
    />
  );
};

export default forwardRef(Link);
